var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-container"},[_c('v-select',{class:_vm.colour,attrs:{"options":_vm.charities,"placeholder":"Search charities ..."},on:{"search":_vm.fetchCharities,"input":_vm.emitSelected},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }